import { BlueGrayButton, buttonPipeCss, RedButton } from 'components/Button'
import Column from 'components/Column'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import styled from 'styled-components'

import Container from '../../Modal/Container'

type PropsType = {
  handleDeleteSubmit: (e: React.SyntheticEvent<any>) => void
  hideDeactivateModal: (e: React.SyntheticEvent<any>) => void
} & WrappedComponentProps

const ButtonBar = styled(Column)`
  padding-top: 0.5rem;
  ${buttonPipeCss};
  width: 300px;
`

const DeactivateApiKey = ({ handleDeleteSubmit, hideDeactivateModal, intl }: PropsType) => (
  <Container
    sub={intl.formatMessage(messages.api_key_delete_sub_title)}
    title={intl.formatMessage(messages.api_key_delete_title)}
  >
    <ButtonBar>
      <RedButton e2e='confirmDeleteKeyButton' onClick={handleDeleteSubmit}>
        {intl.formatMessage(messages.api_button_cancel)}
      </RedButton>

      <BlueGrayButton e2e='cancelButton' onClick={hideDeactivateModal} type='button'>
        {intl.formatMessage(messages.button_cancel)}
      </BlueGrayButton>
    </ButtonBar>
  </Container>
)

export default injectIntl(DeactivateApiKey)
